var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 503,
    viewBox: "0 0 477 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.327 480.276L267.739 340.864H376.813L464.577 253.099V341.586L462.049 252.016H381.147",
    stroke: "black",
    strokeWidth: 23.5497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.218 383.687C134.218 383.687 50.4892 357.434 24.3823 282.58C4.4161 225.332 4.08406 150.887 57.5374 77.9303C110.991 4.97372 212.841 12.1974 212.841 12.1974C212.841 12.1974 350.808 17.9762 383.314 166.056",
    stroke: "black",
    strokeWidth: 23.5497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.039 429.146V492.282",
    stroke: "black",
    strokeWidth: 21.0671,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.593 307.707C207.295 307.609 206.322 307.37 205.429 307.177C203.229 306.702 130.898 234.656 129.39 231.437C128.138 228.765 128.097 226.674 129.226 223.178C130.197 220.169 131.844 218.13 134.455 216.703C136.013 215.851 138.581 215.722 158.913 215.473L181.63 215.193L185.54 213.772C191.366 211.654 194.149 209.831 198.974 204.974C202.129 201.798 203.897 199.463 205.361 196.537L207.385 192.492L171.52 192.22C131.719 191.921 133.72 192.114 130.889 188.299C127.52 183.761 127.52 177.961 130.889 173.423C133.72 169.609 131.719 169.802 171.52 169.502L207.385 169.23L205.361 165.185C203.897 162.259 202.129 159.923 198.974 156.748C194.149 151.89 191.366 150.067 185.54 147.95L181.63 146.529L158.913 146.249L136.195 145.97L133.761 144.617C131.919 143.594 130.966 142.551 129.84 140.328C126.247 133.235 129.735 125.084 137.007 123.579C139.159 123.133 157.937 123.003 204.888 123.107L269.795 123.251L272.4 124.533C276.119 126.364 277.824 129.143 278.087 133.802C278.426 139.794 275.857 143.883 270.661 145.623C269.396 146.046 261.315 146.239 244.78 146.239H220.738L221.952 148.267C225.339 153.927 227.455 158.401 229.179 163.547L231.081 169.226L250.979 169.498C272.457 169.789 272.473 169.793 275.313 172.835C279.265 177.068 279.035 185.515 274.862 189.351C271.86 192.111 270.957 192.216 250.361 192.216H231.163L230.583 194.515C228.973 200.897 226.449 206.586 222.844 211.959C220.027 216.157 211.223 225.195 206.992 228.233C197.373 235.14 185.117 238.733 171.173 238.733H167.593L193.605 264.83C217.864 289.169 219.659 291.098 220.227 293.45C221.267 297.757 219.718 302.259 216.197 305.161C213.82 307.121 209.594 308.368 207.593 307.7V307.707Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialServices);
export default __webpack_public_path__ + "static/media/Financial_Services.b4d290c89cf32df0091030d083cab8ff.svg";
export { ForwardRef as ReactComponent };